export default __webpack_public_path__ + "static/media/BscScan-logo-circle.17cd0c8f.webp";